import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";

import { LoadFailed } from "@/components/shell/EmptyState";

/**
 * A route that threw.
 *
 * Renders inside the shell rather than replacing it, so the sidebar and its
 * sections stay usable — a failed screen should not strand someone on a page
 * with no way to leave it.
 *
 * The message is the error's own text. "Something went wrong" is
 * unactionable, and the specific words are what make a support conversation
 * one message instead of five.
 */
export function RouteError({ error }: ErrorComponentProps) {
  const router = useRouter();

  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col">
      <LoadFailed
        message={messageOf(error)}
        onRetry={() => {
          void router.invalidate();
        }}
      />
    </div>
  );
}

/**
 * `error` is `unknown` because anything can be thrown, and something in a
 * dependency eventually throws a string.
 */
function messageOf(error: unknown): string | undefined {
  if (error instanceof Error) return error.message || undefined;
  if (typeof error === "string") return error || undefined;
  return undefined;
}
